<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-page @page:afterin="afterin">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>
        <navbar-center v-if="navbarSubtitle" :title="storeName" :subtitle="navbarSubtitle" />
        <span v-else>{{ storeName }}</span>
      </f7-nav-title>
      <f7-nav-right>
        <!-- <f7-link :href="`#`" @click="changeLanguage">
          <font-awesome-icon icon="language"/>
        </f7-link> -->
        <f7-link :href="`/stores/${storeId}/history`">
          <div v-if="waitingOrders.length !== 0" id="waiting-order-amount">
            {{ waitingOrders.length }}
          </div>
          <font-awesome-icon icon="history"/>
        </f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div v-if="currentMenu" style="position: absolute; top: 56px; bottom: 48px; width: 100%;">
      <tabs :objects="tabObj" :initPage="showFavoriteTab ? 0 : 1">
        <template slot="tabbar-objects" slot-scope="props">
          {{ props.object.title }}
          <div v-if="props.object.type !== 'static' && categoryItemAmount(props.object.id) > 0" id="category-item-amount">
            {{ categoryItemAmount(props.object.id) }}
          </div>
        </template>
        <template slot="tab-objects" slot-scope="props">
          <div v-if="props.object.type === 'static'">
            <favorites :itemObjs="allFavoriteItems" />
          </div>
          <div v-else style="position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; overflow: auto;" :style="ios12BugStyle">
            <f7-list media-list style="margin: 0px;">
              <f7-list-group v-for="(group, index) in props.object.groups.map(id => currentMenu.groups[id])" :key="`menu-group${group.id}-${index}`">
                <f7-list-item v-if="group.title" :title="group.title" group-title></f7-list-item>
                <f7-list-item v-for="(item, index) in group.items.map(id => currentMenu.items[id])" :key="`menu-items-${item.id}-${index}`" media-item :title="`${item.title} ${item.soldOut ? '(已售完)' : ''}`">
                  <img
                    v-if="item.coverImgUrl"
                    :src="ImageUrlBuilder.url64(item.coverImgUrl, storeId)"
                    :srcset="`${ImageUrlBuilder.url128(item.coverImgUrl, storeId)} 2x, ${ImageUrlBuilder.url192(item.coverImgUrl, storeId)} 3x`"
                    style="width: 64px;"
                    slot="media"
                    alt="餐點圖片">
                  <img v-else slot="media" src="@/assets/itemDefault.jpg" style="width: 64px;" alt="餐點圖片" />
                  <div v-if="item.price !== 0" style="font-size: 14px; color: #888888;">NT${{ parseFloat(item.price) }}</div>
                  <div style="font-size: 14px; color: #888888;">{{ item.description }} </div>
                  <amount-adjustment v-if="!item.soldOut" slot="content" class="amount-adjustment" :id="item.id" :itemObjs="cart[item.id]" :size="27" />
                </f7-list-item>
              </f7-list-group>
            </f7-list>
          </div>
        </template>
      </tabs>
    </div>
    <div v-else class="waiting">
      <div style="position: absolute; top: -40px; left: 50%; transform: translateX(-50%); font-size: 20px;">菜單載入中</div>
      <f7-progressbar infinite color="green"></f7-progressbar>
    </div>
    <f7-segmented id="bottom-toolbar" raised>
      <f7-button :href="`/stores/${storeIdPathParam}/dining-preference`">
        <div>{{ $t(`diningPreferenceType.${diningPreference}`) }}</div>
        <template v-if="diningPreference === diningPreferenceType.forHere">
          <div v-if="tableNumber">{{ tableNumber }}</div>
          <div v-else style="color: red;">{{ $t(`instruction.pleaseSelectTableNumber`) }}</div>
        </template>
        <template v-else-if="diningPreference === diningPreferenceType.preOrder">
          <div v-if="pickupTime">{{ pickupTime | moment("MM/DD HH:mm") }}</div>
          <div v-else style="color: red;">{{ $t(`instruction.pleaseSelectPickUpTime`) }}</div>
        </template>
      </f7-button>
      <f7-button @click="checkValid()" style="display: flex; flex-direction: row;" :style="{ color: errorList.length === 0 ? '#4CAF50' : 'gray', 'fontWeight': 'bold' }">
        <div style="display: flex; flex-direction: column; justify-content: center;">
          <div>${{ subtotal }}</div>
          <div>{{ $t(`instruction.nextStep`) }}  </div>
        </div>
        <i class="material-icons md-only" style="line-height: 36px; margin: 0px -10px 0px 5px; font-weight: bold">arrow_forward</i>
      </f7-button>
    </f7-segmented>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import NavbarCenter from '@/common/components/NavbarCenter'
import AmountAdjustment from '../components/AmountAdjustment'
import Favorites from '../components/Favorites'
import Tabs from '@/common/components/Tabs'
import logoTextImg from '@/assets/ezmeals_logo_text.png'
import bowser from 'bowser'
import i18n from '@/i18n'

export default {
  dependencies: [
    'platformUtils',
    'ImageUrlBuilder',
    'CartElementBuilder',
    'diningPreferenceType'
  ],
  data () {
    return {
      actionButtonSize: 20,
      logoTextImg,
      ios12BugStyle: {
        display: 'block'
      }
    }
  },
  computed: {
    ...mapState(['menuVariation', 'nickname', 'publicId', 'diningPreference', 'tableNumber', 'pickupTime', 'store', 'storeId']),
    ...mapState('itemModule', ['newItem', 'cart', 'favorites']),
    ...mapState('menuModule', ['menus', 'menuVariations', 'businessHours', 'businessHourDirtyStates', 'menuStoreId']),
    ...mapGetters(['currentMenu', 'currentMenuTitle', 'storeId', 'storeName', 'storeBranch', 'fullStoreName', 'businessHours']),
    ...mapGetters('itemModule', ['subtotal', 'allItemObjs', 'allFavoriteItems']),
    ...mapGetters('orderModule', ['waitingOrders']),
    navbarSubtitle () {
      let subtitleContent = []
      if (this.storeBranch) {
        subtitleContent.push(this.storeBranch)
      }
      if (this.menuVariation !== 'main' && this.currentMenuTitle) {
        subtitleContent.push(this.currentMenuTitle)
      }
      return subtitleContent.join(' - ')
    },
    showFavoriteTab () {
      return Object.keys(this.favorites || {}).map(k => (this.favorites || {})[k])
        .some(items => Object.keys(items).length > 0)
    },
    tabObj () {
      return [{ type: 'static', title: '最愛' }]
        .concat(Object.keys(this.currentMenu.categories || {})
          .map(k => (this.currentMenu.categories || {})[k])
          .sort((a, b) => a.categoryOrder - b.categoryOrder))
    },
    errorList () {
      const errorList = []
      if (this.allItemObjs.length === 0) {
        errorList.push('請將至少一樣物品放入購物車')
      }
      if (this.diningPreference === this.diningPreferenceType.forHere && !this.tableNumber) {
        errorList.push('桌號未填寫')
      }
      if (this.diningPreference === this.diningPreferenceType.preOrder && !this.pickupTime) {
        errorList.push('請選擇預約時間')
      }
      if (this.diningPreference === this.diningPreferenceType.preOrder &&
        moment(this.pickupTime).diff(moment(new Date()), 'minutes') < this.availableTime - 5) {
        errorList.push(`預約外帶請在 ${this.availableTime - 5} 分鐘之前預約`)
      }
      return errorList
    }
  },
  watch: {
    newItem (itemObj) {
      const item = this.CartElementBuilder.buildItem(itemObj, this.currentMenu)
      if (item.questionIds.length !== 0 || item.allowSpecialRequests) {
        this.$f7router.navigate(`/stores/${this.storeId}/items/cart/${item.id}.${item.stateObj.instanceId}/questions`)
      }
    },
    businessHours () {
      if (!this.checkShopOpen()) {
        if (this.store.isSupportTakeout) {
          return this.$f7.dialog.alert('現在非營業時間，可預約外帶')
        } else {
          return this.$f7.dialog.alert('現在非營業時間')
        }
      }
    }
  },
  props: {
    storeIdPathParam: String,
    menuVariationPathParam: {
      type: String,
      default: 'main'
    }
  },
  async created () {
    /**
     * 總共需要 load 進來的有 menu 跟 loaclforage 裡的餐點資料 (上次未點完的餐點跟最愛裡面的餐點)
     * 順序
     * 1. reset buckets, reset menus
     * 2. set storeId, menu variation
     * 3. download menu (depends on storeId (2), variation(2))
     * 4. download history orders (depends on storeId (2))
     * 5. load buckets from loaclforage (load 進來之後需要 menu 才能顯示在畫面上，不然 vue template 會讀不到東西)
     */

    if (this.getQueryString('tn')) {
      this.setTableNumber(this.getQueryString('tn'))
    }

    this.setMenuVariation(this.menuVariationPathParam)

    await this.setStore(this.storeIdPathParam)
    if (this.store.showAnnouncement) {
      this.$f7.dialog.alert(this.store.announcement, '公告')
    }

    // 要等 set 完 storeId, menu variation 才能下載 menu
    this.downloadMenu({ variation: this.menuVariationPathParam })
    document.title = this.fullStoreName
    await this.downloadBusinessHours({ menuVariation: this.menuVariationPathParam })
    // await this.checkTodayOpened();
    /** TODO: 之前要把 orderId 存下來
     * 用 agentId (jwt token) 到 server 檢查 (agentId 放在 header auth)
     *   1. 存在 localforage 裡面的訂單是不是已經完成付款了
     * 如果 local 的這筆訂單已經付款，就要從裝置上刪掉 local 的這筆訂單
     */
    if (this.getQueryString('dp')) {
      if (this.getQueryString('dp') === this.diningPreferenceType.preOrder && !this.store.isSupportTakeout) {
        this.setDiningPreference(this.diningPreferenceType.forHere)
        this.$f7.dialog.alert('目前本店暫不接收預約外帶')
      } else {
        this.setDiningPreference(this.getQueryString('dp'))
      }
    }

    if (this.getQueryString('lang') === 'en') {
      i18n.locale = 'en'
    }
  },
  components: {
    NavbarCenter,
    AmountAdjustment,
    Favorites,
    Tabs
  },
  methods: {
    afterin () {
      // 如果放在 created or mounted 的話，程式太早抓到 url 的話有可能會抓到上一頁的 url
      this.setMenuUrl(document.location.pathname + document.location.search)

      // iOS 12 特別會出現的問題 https://github.com/ionic-team/ionic-v3/issues/984#issuecomment-470747029
      // 如果不這樣，就會出在新增完餐點回到 menu 的時候出錯
      const ua = bowser._detect ? bowser._detect(navigator.userAgent) : bowser
      if (ua && ua.ios && ua.safari && parseInt(ua.osversion, 10) === 12) {
        this.ios12BugStyle = {
          display: 'inline-block'
        }
        setTimeout(() => {
          this.ios12BugStyle = {
            display: 'block'
          }
        }, 1000)
      }
    },
    getQueryString (name) {
      const url = window.location.href
      name = name.replace(/[[\]]/g, '\\$&')
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
      const results = regex.exec(url)
      if (!results) {
        return null
      }
      if (!results[2]) {
        return ''
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },
    categoryItemAmount: function (id) {
      return this.currentMenu.categories[id].groups.map(gid =>
        this.currentMenu.groups[gid].items
      ).reduce((items, i) => items.concat(i), []).map(id => // all ids in this category
        this.cart[id] === undefined ? 0 : Object.keys(this.cart[id]).length).reduce((s, n) => s + n, 0)
    },
    checkShopOpen () {
      // 檢查店家是否營業
      let key = Object.keys(this.businessHours)[0]
      if (this.diningPreference === 'preOrder') { // 如果是預約外帶，則不會跳出警告訊息
        return true
      } else if (this.businessHours[key].length === 0) { // 如果今日公休，跳出警告訊息
        return false
      } else {
        let result = this.businessHours[key].some(item => {
          const startHour = item[0].split(':')[0]
          const startMinute = item[0].split(':')[1]
          const endHour = item[1].split(':')[0]
          const endMinute = item[1].split(':')[1]
          const momentStart = moment().hours(startHour).minutes(startMinute).seconds(0)
          const momentEnd = moment().hours(endHour).minutes(endMinute).seconds(0)

          // 如果還沒到營業時間 或者 營業時間已經超過現在時間 回傳 false，否則回傳 true
          if (momentStart.isAfter(new Date()) || momentEnd.isBefore(new Date())) {
            return false
          } else {
            return true
          }
        })
        return result
      }
    },
    checkValid () {
      if (!this.checkShopOpen()) {
        if (this.store.isSupportTakeout) {
          return this.$f7.dialog.alert('現在非營業時間，可預約外帶')
        } else {
          return this.$f7.dialog.alert('現在非營業時間')
        }
      }
      if (this.errorList.length !== 0) {
        this.$f7.dialog.alert('*' + this.errorList.join('<br>*'), '請更正訂單')
      } else {
        this.$f7router.navigate(`/stores/${this.storeId}/order`)
      }
    },
    changeLanguage () {
      i18n.locale = i18n.locale === 'en' ? 'zh-tw' : 'en'
    },
    ...mapActions([
      'setStore',
      'setDiningPreference',
      'setTableNumber',
      'setMenuUrl',
      'setMenuVariation',
      'downloadBusinessHours'
    ]),
    ...mapActions('menuModule', ['downloadMenu'])
  }
}
</script>

<style lang="scss" scoped>
#category-item-amount {
  display: inline-block;
  position: absolute;
  right: 5px;
  top: 8px;
  border-radius: 50%;
  text-align: center;
  width: 15px;
  height: 15px;
  line-height: 15px;
  font-size: 12px;
  color: white;
  background-color: red;
}
#waiting-order-amount {
  display: inline-block;
  position: absolute;
  right: 8px;
  top: 10px;
  border-radius: 50%;
  text-align: center;
  width: 15px;
  height: 15px;
  line-height: 15px;
  font-size: 12px;
  color: white;
  background-color: red;
  z-index: 10;
}
.action-button-icon {
  position: relative;
  top: -2px;
  margin: 0px 10px;
}
.amount-adjustment {
  margin: 0px 10px 0px -27px;
  /*position: absolute;
  top: 50%;
  right: 0px;
  transform: translate(-50%, -50%);*/
}
.waiting {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 300px;
}
#bottom-toolbar {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 48px;
  z-index: 15;
  margin: 0px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

#bottom-toolbar a {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#bottom-toolbar a div {
  line-height: 18px;
}
</style>
